// SearchWorkflowService.ts

import { SearchWorkflowInitializeResponse } from "../type/response/SearchWorkflowResponse";
import { axiosRequest } from "./AxiosService";
import { FilteredData } from "../pages/searchWorkflow/SearchWorkflowContainer";

/**
 * ワークフロー検索用データを取得し、表示用の形式に変換して返す
 * @returns ワークフロー一覧データ、取得失敗時は空配列
 */
export const getWorkflow = async () => {
  // get通信の場合
  const response: Promise<SearchWorkflowInitializeResponse[]> = axiosRequest(
    "/searchWorkflow/initialize",
    "GET"
  );
  if (response !== undefined) {
    let workflowDataList: FilteredData[] = [];
    (await response).forEach((value) => {
      let workflowData = {
        id: value.id,
        mainName: value.name,
        type: value.type,
        overview: value.description,
      };
      workflowDataList.push(workflowData);
    });
    return workflowDataList;
  } else {
    return [];
  }
};
